export enum ELoadingType {
  GIF = 'gif-loading',
  SPINNER = 'spinner',
  THREE_SQUARES = 'three-squares',
}
